<template>
    <v-menu
        bottom
        left
        offset-y
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                icon
                :title="`Theme: ${themeModeLabel}`"
                v-bind="attrs"
                v-on="on"
            >
                <v-icon class="material-icons-outlined">
                    {{ themeModeIcon }}
                </v-icon>
            </v-btn>
        </template>
        <v-list
            dense
            width="180"
        >
            <v-subheader>Theme</v-subheader>
            <v-list-item
                v-for="option in options"
                :key="option.value"
                :input-value="themeMode === option.value"
                @click="selectThemeMode(option.value)"
            >
                <v-list-item-icon>
                    <v-icon class="material-icons-outlined">
                        {{ option.icon }}
                    </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ option.label }}
                    </v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon v-if="themeMode === option.value">
                    <v-icon color="primary">
                        check
                    </v-icon>
                </v-list-item-icon>
            </v-list-item>
        </v-list>
    </v-menu>
</template>
<script>
import {
    applyThemeMode,
    getStoredThemeMode,
    storeThemeMode,
    themeModes,
    watchSystemTheme,
} from '@/services/themeMode';

const options = [
    {
        value: themeModes.system,
        label: 'System',
        icon: 'brightness_auto',
    },
    {
        value: themeModes.light,
        label: 'Light',
        icon: 'light_mode',
    },
    {
        value: themeModes.dark,
        label: 'Dark',
        icon: 'dark_mode',
    },
];

export default {
    name: 'ThemeModeControl',
    data() {
        return {
            options,
            stopWatchingSystemTheme: null,
            themeMode: getStoredThemeMode(),
        };
    },
    computed: {
        selectedOption() {
            return this.options.find(option => option.value === this.themeMode);
        },
        themeModeIcon() {
            return this.selectedOption.icon;
        },
        themeModeLabel() {
            return this.selectedOption.label;
        },
    },
    mounted() {
        applyThemeMode(this.$vuetify, this.themeMode);
        this.stopWatchingSystemTheme = watchSystemTheme(isDark => {
            if(this.themeMode === themeModes.system) {
                this.$vuetify.theme.dark = isDark;
            }
        });
    },
    destroyed() {
        this.stopWatchingSystemTheme?.();
    },
    methods: {
        selectThemeMode(mode) {
            this.themeMode = mode;
            storeThemeMode(mode);
            applyThemeMode(this.$vuetify, mode);
        },
    },
};
</script>
